import {
  assertDataViewActionIsConstant,
  OverflowDataViewAction,
} from 'analysis-tool/data-view/DataViewContext';
import PersistedDataFrameMetadataModal, {
  PersistedDataFrameMetadataModalProps,
} from 'data-frames/modals/PersistedDataFrameMetadataModal';
import {DataFrameTableWrapperOverflowOption} from 'data-frames/wrapper/DataFrameTableWrapper';
import {PersistedDataFrameGraphQL} from 'data-frames/wrapper/PersistedDataFrameTableWrapper';
import runModal from 'ui-library/runModal';

/**
 * TODO(BNCH-123685): Move to analysis-tool/data-view/ module one `getMetadataModalOverflowActionForDataFrameTable` is removed.
 */
export default function getMetadataModalOverflowAction(
  persistedDataFrame: PersistedDataFrameGraphQL,
  additionalMetadataModalContent?: Pick<
    PersistedDataFrameMetadataModalProps,
    'additionalGridCells' | 'additionalContent'
  >
): OverflowDataViewAction {
  return {
    icon: 'info-circle',
    onClick: () => {
      runModal(PersistedDataFrameMetadataModal, {
        persistedDataFrame,
        ...additionalMetadataModalContent,
      });
    },
    label: 'Table metadata',
  };
}

/**
 * @deprecated TODO(BNCH-123685): Remove once uses of DataFrameTableWrapper are removed.
 */
export function getMetadataModalOverflowActionForDataFrameTable(
  persistedDataFrame: PersistedDataFrameGraphQL,
  additionalMetadataModalContent?: Pick<
    PersistedDataFrameMetadataModalProps,
    'additionalGridCells' | 'additionalContent'
  >
): DataFrameTableWrapperOverflowOption {
  const action = getMetadataModalOverflowAction(persistedDataFrame, additionalMetadataModalContent);
  assertDataViewActionIsConstant(action);

  return {
    icon: action.icon,
    onSelect: action.onClick,
    title: action.label,
  };
}
